export const CARE_HISTORY_CSV_COL_JA = [
  {
    label: '入居者ID',
    value: 'residentId',
  },
  {
    label: '氏名',
    value: 'name',
  },
  {
    label: '施設名',
    value: 'facilityName',
  },
  {
    label: 'ユニット名',
    value: 'unitName',
  },
  {
    label: '部屋名',
    value: 'roomName',
  },
  {
    label: '日時',
    value: 'timestamp',
  },
  {
    label: '場所',
    value: 'place',
  },
  {
    label: '排尿有無（トイレ）',
    value: 'urinatedToilet',
  },
  {
    label: '排尿量（トイレ）',
    value: 'toiletUrineVolume',
  },
  {
    label: '排尿量種別（おむつ）',
    value: 'padUrineVolumeType',
  },
  {
    label: '排尿量（おむつ）',
    value: 'padUrineVolume',
  },
  {
    label: '失禁・空振り',
    value: 'incontinence',
  },
  {
    label: '切迫感',
    value: 'isUrgency',
  },
  {
    label: '衣類・シーツ汚染（尿）',
    value: 'isLeakOutUrine',
  },
  {
    label: '排便量',
    value: 'defecation',
  },
  {
    label: '排便形態',
    value: 'hardnessType',
  },
  {
    label: '衣類・シーツ汚染（便）',
    value: 'isLeakOutFeces',
  },
  {
    label: 'テープ/パンツ交換',
    value: 'diaperName',
  },
  {
    label: 'テープ/パンツ交換サイズ',
    value: 'diaper',
  },
  {
    label: 'パッド交換1枚目',
    value: 'padFirstName',
  },
  {
    label: 'パッド交換1枚目サイズ',
    value: 'padFirst',
  },
  {
    label: 'パッド交換2枚目',
    value: 'padSecondName',
  },
  {
    label: 'パッド交換2枚目サイズ',
    value: 'padSecond',
  },
  {
    label: '飲水名',
    value: 'drinkName',
  },
  {
    label: '飲水量',
    value: 'drinkingVolume',
  },
  {
    label: '下剤名',
    value: 'laxative',
  },
  {
    label: '下剤種別',
    value: 'laxativeType',
  },
  {
    label: '下剤量',
    value: 'laxativeAmount',
  },
  {
    label: 'メモ',
    value: 'memo',
  },
  {
    label: '担当職員',
    value: 'staffName',
  },
  {
    label: 'ケア時間（分）',
    value: 'workingTime',
  },
];

export const CARE_HISTORY_CSV_COL_EN = [
  {
    label: 'Resident ID',
    value: 'residentId',
  },
  {
    label: 'Full name',
    value: 'name',
  },
  {
    label: 'Facility name',
    value: 'facilityName',
  },
  {
    label: 'Unit name',
    value: 'unitName',
  },
  {
    label: 'Room name',
    value: 'roomName',
  },
  {
    label: 'Date time',
    value: 'timestamp',
  },
  {
    label: 'Place',
    value: 'place',
  },
  {
    label: 'Urinated toilet',
    value: 'urinatedToilet',
  },
  {
    label: 'Toilet urine volume',
    value: 'toiletUrineVolume',
  },
  {
    label: 'Pad urine volume type',
    value: 'padUrineVolumeType',
  },
  {
    label: 'Pad urine volume',
    value: 'padUrineVolume',
  },
  {
    label: 'Incontinence',
    value: 'incontinence',
  },
  {
    label: 'Is urgency',
    value: 'isUrgency',
  },
  {
    label: 'Is leak out urine',
    value: 'isLeakOutUrine',
  },
  {
    label: 'Defecation',
    value: 'defecation',
  },
  {
    label: 'Defecation hardness type',
    value: 'hardnessType',
  },
  {
    label: 'Is leak out feces',
    value: 'isLeakOutFeces',
  },
  {
    label: 'Diaper name',
    value: 'diaperName',
  },
  {
    label: 'Diaper',
    value: 'diaper',
  },
  {
    label: 'Pad first name',
    value: 'padFirstName',
  },
  {
    label: 'Pad first',
    value: 'padFirst',
  },
  {
    label: 'Pad second name',
    value: 'padSecondName',
  },
  {
    label: 'Pad second',
    value: 'padSecond',
  },
  {
    label: 'Drink name',
    value: 'drinkName',
  },
  {
    label: 'Drinking volume',
    value: 'drinkingVolume',
  },
  {
    label: 'Laxative name',
    value: 'laxative',
  },
  {
    label: 'Laxative type',
    value: 'laxativeType',
  },
  {
    label: 'Laxative amount',
    value: 'laxativeAmount',
  },
  {
    label: 'Memo',
    value: 'memo',
  },
  {
    label: 'Personnel in charge',
    value: 'staffName',
  },
  {
    label: 'Care time',
    value: 'workingTime',
  },
];

export const DIALY_CSV_COL_JA = [
  {
    label: '利用者ID',
    value: 'residentId',
  },
  {
    label: '氏名',
    value: 'name',
  },
  {
    label: '施設名',
    value: 'facilityName',
  },
  {
    label: 'ユニット名',
    value: 'unitName',
  },
  {
    label: '部屋名',
    value: 'roomName',
  },
  {
    label: '日時',
    value: 'timestamp',
  },
  {
    label: '排尿有無（トイレ）',
    value: 'urinatedToilet',
  },
  {
    label: '排尿量（トイレ）',
    value: 'toiletUrineVolume',
  },
  {
    label: '排尿量種別（おむつ）',
    value: 'padUrineVolumeType',
  },
  {
    label: '排尿量（おむつ）',
    value: 'padUrineVolume',
  },
  {
    label: '残尿量',
    value: 'ruv',
  },
  {
    label: 'たまり具合',
    value: 'accumulation',
  },
  {
    label: '姿勢',
    value: 'posture',
  },
  {
    label: '尿もれ',
    value: 'urineLeakage',
  },
  {
    label: '切迫感',
    value: 'isUrgency',
  },
  {
    label: '失禁・空振り',
    value: 'incontinence',
  },
  {
    label: '衣類・シーツ汚染（尿）',
    value: 'isLeakOutUrine',
  },
  {
    label: '場所',
    value: 'place',
  },
  {
    label: '排便量',
    value: 'defecation',
  },
  {
    label: '排便形態',
    value: 'hardnessType',
  },
  {
    label: '衣類・シーツ汚染（便）',
    value: 'isLeakOutFeces',
  },
  {
    label: 'テープ/パンツ交換',
    value: 'diaperName',
  },
  {
    label: 'テープ/パンツ交換サイズ',
    value: 'diaper',
  },
  {
    label: 'パッド交換1枚目',
    value: 'padFirstName',
  },
  {
    label: 'パッド交換1枚目サイズ',
    value: 'padFirst',
  },
  {
    label: 'パッド交換2枚目',
    value: 'padSecondName',
  },
  {
    label: 'パッド交換2枚目サイズ',
    value: 'padSecond',
  },
  {
    label: '飲水名',
    value: 'drinkName',
  },
  {
    label: '飲水量',
    value: 'drinkingVolume',
  },
  {
    label: '下剤名',
    value: 'laxative',
  },
  {
    label: '下剤種別',
    value: 'laxativeType',
  },
  {
    label: '下剤量',
    value: 'laxativeAmount',
  },
  {
    label: 'メモ',
    value: 'memo',
  },
  {
    label: '担当職員',
    value: 'staffName',
  },
  {
    label: 'ケア時間（分）',
    value: 'workingTime',
  },
];

export const DIALY_CSV_COL_EN = [
  {
    label: 'Resident ID',
    value: 'residentId',
  },
  {
    label: 'Full name',
    value: 'name',
  },
  {
    label: 'Facility name',
    value: 'facilityName',
  },
  {
    label: 'Unit name',
    value: 'unitName',
  },
  {
    label: 'Room name',
    value: 'roomName',
  },
  {
    label: 'Date time',
    value: 'timestamp',
  },
  {
    label: 'Urinated toilet',
    value: 'urinatedToilet',
  },
  {
    label: 'Toilet urine volume',
    value: 'toiletUrineVolume',
  },
  {
    label: 'Pad urine volume type',
    value: 'padUrineVolumeType',
  },
  {
    label: 'Pad urine volume',
    value: 'padUrineVolume',
  },
  {
    label: 'Residual urine (ml)',
    value: 'ruv',
  },
  {
    label: 'Urine level',
    value: 'accumulation',
  },
  {
    label: 'Posture',
    value: 'posture',
  },
  {
    label: 'Leak',
    value: 'urineLeakage',
  },
  {
    label: 'Urgency',
    value: 'isUrgency',
  },
  {
    label: 'Incontinence',
    value: 'incontinence',
  },
  {
    label: 'Is leak out urine',
    value: 'isLeakOutUrine',
  },
  {
    label: 'Place',
    value: 'place',
  },
  {
    label: 'Defecation',
    value: 'defecation',
  },
  {
    label: 'Defecation hardness type',
    value: 'hardnessType',
  },
  {
    label: 'Is leak out feces',
    value: 'isLeakOutFeces',
  },
  {
    label: 'Diaper name',
    value: 'diaperName',
  },
  {
    label: 'Diaper',
    value: 'diaper',
  },
  {
    label: 'Pad first name',
    value: 'padFirstName',
  },
  {
    label: 'Pad first',
    value: 'padFirst',
  },
  {
    label: 'Pad second name',
    value: 'padSecondName',
  },
  {
    label: 'Pad second',
    value: 'padSecond',
  },
  {
    label: 'Drink name',
    value: 'drinkName',
  },
  {
    label: 'Drinking volume',
    value: 'drinkingVolume',
  },
  {
    label: 'Laxative name',
    value: 'laxative',
  },
  {
    label: 'Laxative type',
    value: 'laxativeType',
  },
  {
    label: 'Laxative amount',
    value: 'laxativeAmount',
  },
  {
    label: 'Memo',
    value: 'memo',
  },
  {
    label: 'Personnel in charge',
    value: 'staffName',
  },
  {
    label: 'Care time',
    value: 'workingTime',
  },
];
